import { MUTATIONS_CONFIGURATIONS } from "./mutations";
import ConfigurationApi from "../../../api/generic/configuration-api";
import logService from '@/services/logService';

export default {
  updateConfigurationsAPI({ commit }, { configurations, user }) {
    const configurationApi = new ConfigurationApi(user);

    configurationApi.updateList(configurations)
      .then((response) => {
        //Atualizar sempre todas as configurações.
        commit(MUTATIONS_CONFIGURATIONS.UPDATE_CONFIGURATIONS, response.data);
      })
      .catch((error) => {
        logService.error('Não foi possível atualizar configurações via API', error);
      });
  },

  updateConfigurationsModel({ commit }, configurations) {
    commit(MUTATIONS_CONFIGURATIONS.UPDATE_CONFIGURATIONS, configurations);
  }
};